import { axios } from '../../services/axios';

export default async function getTrunks(companyId) {
    return await axios
        .get(`/Trunks/${companyId}`, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        })
        .then((res) => res)
        .catch((e) => e);
}
